import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/robot-removebg-preview.avif";
import './Banner.css';

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Fullstack Developer", "Estudiante de ciberseguridad"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(50);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta)

        return () => { clearInterval(ticker) };
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(40)
        }
        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(60 + Math.random() * 10)
        }
    }

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={6} className="text-center">

                        <h1>{`Juan Ángel Peñarrubia`}</h1>
                        <h2>
                            {/* Span invisible que reserva el espacio del texto más largo */}
                            <span className="wrap placeholder" aria-hidden="true">
                                Estudiante de ciberseguridad
                            </span>
                            {/* Tu texto animado */}
                            <span className="wrap">{text || '\u00A0'}</span>
                        </h2>
                        <p>Desarrollador full-stack con sólida base en ciberseguridad. Creando soluciones web end-to-end: interfaces modernas, APIs robustas y despliegue en cloud.</p>
                        <button onClick={() => document.getElementById('contact')?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        })}>Contacta conmigo <ArrowRightCircle size={25} /></button>
                    </Col>
                    <Col xs={12} md={6} xl={6}>
                        <img src={headerImg} alt="Header Img" />
                    </Col>
                </Row>
            </Container>
        </section >
    )
}